//  Angular imports
import { Component } from '@angular/core';

@Component({
    selector: 'zf-loading-indicator',
    templateUrl: './loading-indicator.component.html',
    styleUrls: ['./loading-indicator.component.scss']
})
export class LoadingIndicatorComponent { }
